import { Box, Typography } from "@mui/material";

const SaleInvoiceTermsAndSubmit = ({ data }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Terms & Conditions</Typography>
      <Typography>1. Electronically generated invoice.</Typography>
      <Typography>2. Jurisdiction: Rampur only.</Typography>
      <Typography sx={{ mt: 2 }}>Certified by: <strong>{data?.registrationData?.accountHolderName || "N/A"}</strong></Typography>
    </Box>
  );
};

export default SaleInvoiceTermsAndSubmit;
